import { Col, Row, Typography } from "antd";

import OpenInsureFooter from "../../components/home/Footer";

const { Title, Paragraph } = Typography;

export default function Referral() {
    return (
        <>
            <div style={{ padding: 24 }}>
                <Row>
                    <Col lg={{ span: 4 }} sm={{ span: 22, offset: 2 }}>
                        <Title level={2}>
                            Referral Program Terms and Conditions
                        </Title>
                    </Col>
                    <Col lg={{ span: 12 }} sm={{ span: 22, offset: 2 }}>
                        <Title level={4}>Effective Date</Title>
                        <Paragraph>April 19, 2025</Paragraph>

                        <Title level={4}>Program Overview</Title>
                        <Paragraph>
                            The Referral Program allows current Open Insure Inc.
                            users ("Participants") to earn rewards by referring
                            eligible individuals to Open Insure Inc.’s services.
                            Rewards are awarded lottery-style, with participants
                            earning a chance to win a randomly assigned bonus
                            amount of $1, $10, $100, or $1,000, subject to the
                            rules outlined below.
                        </Paragraph>

                        <Title level={4}>How it works</Title>
                        <Title level={5}>Referral reward process</Title>
                        <Paragraph>
                            Participants who refer eligible users will receive a
                            chance to win a reward amount of $1, $10, $100, or
                            $1,000. Rewards are distributed based on the
                            following probabilities:
                        </Paragraph>
                        <ul>
                            <li>
                                <strong>$1,000:</strong> 0.01% (1 in 10,000
                                referrals)
                            </li>
                            <li>
                                <strong>$100:</strong> 0.1% (1 in 1,000
                                referrals)
                            </li>
                            <li>
                                <strong>$10:</strong> 30%
                            </li>
                            <li>
                                <strong>$1:</strong> 69.89%
                            </li>
                        </ul>
                        <Title level={5}>Payout Details</Title>
                        <Paragraph>
                            <strong>50% Immediate Payout:</strong> Half of the
                            earned Referral Reward will be paid to Participants
                            immediately after the referred user meets all
                            eligibility requirements.
                        </Paragraph>
                        <Paragraph>
                            <strong>50% End-of-Year Payout:</strong> The
                            remaining half will be paid out at the end of the
                            plan cycle, provided the Participant and referred
                            user both remain active and maintain recurring
                            transfers as defined below.
                        </Paragraph>

                        <Title level={5}>
                            Eligibility for Referral Rewards
                        </Title>
                        <Paragraph>Referred users must:</Paragraph>
                        <ul>
                            <li>
                                Be new customers who have not previously signed
                                up for Open Insure Inc. services.
                            </li>
                            <li>
                                Create an account using the referral code or
                                link provided by the Participant.
                            </li>
                            <li>
                                Set up and maintain a valid recurring transfer
                                during the Program period.
                            </li>
                        </ul>
                        <Paragraph>
                            Participants must also have an active account with
                            recurring transfers scheduled to qualify for payout
                            of the end-of-year portion.
                        </Paragraph>

                        <Title level={5}>Reward Cap</Title>
                        <Paragraph>
                            The total payout for the Referral Program is capped
                            at $3,000 for the entire program duration. If the
                            cap is reached, Open Insure Inc. reserves the right
                            to adjust reward probabilities or end the Program.
                        </Paragraph>

                        <Title level={4}>Program Limitations</Title>
                        <Title level={5}>Probability Adjustment</Title>
                        <Paragraph>
                            Open Insure Inc. reserves the right to adjust reward
                            probabilities after the initial $3,000 in rewards is
                            distributed to ensure the Program remains
                            financially sustainable.
                        </Paragraph>
                        <Title level={5}>Reward Distribution</Title>
                        <Paragraph>
                            Rewards are non-transferable and cannot be exchanged
                            for other benefits. Rewards may be delayed in cases
                            of suspected fraud or abuse of the Program.
                        </Paragraph>
                        <Title level={5}>Program Termination</Title>
                        <Paragraph>
                            Open Insure Inc. may suspend or terminate the
                            Program at any time without prior notice. Rewards
                            earned prior to suspension or termination will still
                            be honored, subject to these Terms.
                        </Paragraph>

                        <Title level={4}>Eligibility and Participation</Title>
                        <Paragraph>
                            <strong>Participant Eligibility:</strong> You must
                            be 18 years of age or older and reside in New York
                            State. Employees, contractors, or agents of Open
                            Insure Inc., and their immediate family members, are
                            not eligible.
                        </Paragraph>
                        <Paragraph>
                            <strong>Valid Referrals:</strong> Referrals will
                            only count if the referred user meets the
                            eligibility criteria outlined above and fully
                            activates their account with a recurring transfer.
                        </Paragraph>
                        <Paragraph>
                            <strong>Prohibited Conduct:</strong> Participants
                            must not engage in fraudulent, deceptive, or
                            unethical practices to earn referrals, including but
                            not limited to:
                        </Paragraph>
                        <ul>
                            <li>Creating fake accounts.</li>
                            <li>Misleading referred users.</li>
                            <li>
                                Using unauthorized platforms to share referral
                                codes or links.
                            </li>
                        </ul>
                        <Paragraph>
                            Violations of these Terms may result in
                            disqualification from the Program and forfeiture of
                            rewards.
                        </Paragraph>

                        <Title level={4}>Taxes and Reporting</Title>
                        <Paragraph>
                            Referral Rewards may be subject to taxation.
                            Participants are solely responsible for reporting
                            and paying any applicable taxes on rewards received
                            through the Program.
                        </Paragraph>

                        <Title level={4}>Limitation of Liability</Title>
                        <Paragraph>
                            <strong>No Guarantee:</strong> Open Insure Inc. does
                            not guarantee any specific reward amount or the
                            availability of rewards. Open Insure Inc. reserves
                            the right to change reward probabilities or
                            discontinue the Program at its sole discretion.
                        </Paragraph>
                        <Paragraph>
                            <strong>Maximum Liability:</strong> To the fullest
                            extent permitted by law, Open Insure Inc. shall not
                            be liable for any indirect, incidental, or
                            consequential damages arising from participation in
                            the Program.
                        </Paragraph>
                        <Paragraph>
                            <strong>Force Majeure:</strong> Open Insure Inc. is
                            not responsible for delays or failures in Program
                            execution due to circumstances beyond its control,
                            such as natural disasters, technical failures, or
                            regulatory changes.
                        </Paragraph>

                        <Title level={4}>Changes to the Program</Title>
                        <Paragraph>
                            Open Insure Inc. reserves the right to modify these
                            Terms, the reward structure, or other aspects of the
                            Program at any time. Any changes will be posted
                            publicly on our website and will apply on a
                            prospective basis.
                        </Paragraph>

                        <Title level={4}>Dispute Resolution</Title>
                        <Paragraph>
                            Any disputes arising from or related to the Program
                            will be governed by the laws of New York State and
                            resolved through binding arbitration, except where
                            prohibited by law.
                        </Paragraph>

                        <Title level={4}>Contact Us</Title>
                        <Paragraph>
                            If you have questions or concerns about the Referral
                            Program or these Terms, please contact us at:
                        </Paragraph>
                        <Paragraph>
                            <strong>Email:</strong> jack@openinsure.app
                        </Paragraph>
                    </Col>
                </Row>
            </div>
            <div style={{ marginTop: 100 }} />
            <OpenInsureFooter key="footer" />
        </>
    );
}
